import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import FormError from "../Components/FormError";
import { requiredValidator, validateUsername } from "../Components/FormValidations";
import { generalPostFunction } from "../Globals/globalFunctions";
import { useNavigate } from "react-router-dom";
import { gameName } from "../Globals/globalMetaData";

function Login({ requiredLevel = 0, roleName = "Admin" }) {
	const {
		register,
		formState: { errors },
		handleSubmit,
	} = useForm();
	const navigate = useNavigate();
	const account = JSON.parse(localStorage.getItem("account"));
	const [loginError, setLoginError] = useState("");

	useEffect(() => {
		if (account && account?.username && Number(account.level) === requiredLevel) {
			navigate("/");
		}
	}, [account, navigate, requiredLevel]);

	const handleLogin = async (data) => {
		const payload = {
			username: data.username,
			password: data.password,
		};
		try {
			const response = await generalPostFunction("/getuserdata", payload, "3040");
			if (response && Number(response.level) === requiredLevel) {
				setLoginError("");
				localStorage.setItem("account", JSON.stringify(response));
				navigate("/");
			} else if (response) {
				localStorage.removeItem("account");
				setLoginError(`This login is only available to ${roleName} accounts.`);
			}
		} catch (err) {
			setLoginError("Unable to log in with those credentials.");
		}
	};

	return (
		<>
			<nav class="navbar navbar-custom p-0" role="navigation">
				<div class="container-fluid">
					<div class="navbar-header">
						<a class="navbar-brand">
							<span>
								<img src="/assets/images/logo.png" width="94" height="70" style={{ objectFit: "contain" }} /> {gameName}{" "}
							</span>
							{/* {account?.level == "0" ? "Admin" : "SubAdmin"} */}
						</a>
					</div>
				</div>
			</nav>
			<div className="layout">
				<main>
					<div class="col-xl-4 col-md-8 col-10 mx-auto">
						<div class="login-panel panel panel-default">
							<div class="panel-heading">{roleName ? `${roleName} Log in` : "Log in"}</div>
							<div class="panel-body">
								<form onSubmit={handleSubmit(handleLogin)}>
									<div class="form-group">
										<input class="form-control" placeholder="Username" type="text" {...register("username", requiredValidator)} />
										{errors.username && <FormError message={errors.username.message} />}
									</div>
									<div class="form-group">
										<input class="form-control" placeholder="Password" type="password" {...register("password", requiredValidator)} />
										{errors.password && <FormError message={errors.password.message} />}
										{loginError && <FormError message={loginError} />}
									</div>
									<div class="form-check">
										<input class="form-check-input" type="checkbox" value="" id="checkDefault" />
										<label class="form-check-label" for="checkDefault">
											Remember Me
										</label>
									</div>
									<button type="submit" class="btn btn-primary">
										Login
									</button>
								</form>
							</div>
						</div>
					</div>
				</main>
			</div>
		</>
	);
}

export default Login;
